import axios from "./axios";

const SettingsService = {

  deleteReservationSlots: async (id,slotId) => {
    try {
      const response = await axios.delete(`restaurant/${id}/reservation_slots/${slotId}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  addReservationSlots: async (id,payload) => {
    try {
      const response = await axios.post(`restaurant/${id}/reservation_slots`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateReservationSlots: async (id,payload,slotId) => {
    try {
      const response = await axios.put(`restaurant/${id}/reservation_slots/${slotId}`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getReservationSlots: async (id) => {
    try {
      const response = await axios.get(`restaurant/${id}/reservation_slots`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
 
  getOperatingHours: async (id) => {
    try {
      const response = await axios.get(`restaurant/${id}/operating-hours`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },

  getHolidays: async (id) => {
    try {
      const response = await axios.get(`restaurant/${id}/holidays`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },

  createHolidays: async (id,payload) => {
    try {
      const response = await axios.post(`restaurant/${id}/holidays`,payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },

  deleteHolidays: async (id,holidayId) => {
    try {
      const response = await axios.delete(`restaurant/${id}/holidays/${holidayId}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },

  addOperatingHours: async (id,payload) => {
    try {
      const response = await axios.post(`restaurant/${id}/operating-hours`,payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateOperatingHours: async (id,payload,hourId) => {
    try {
      const response = await axios.put(`restaurant/${id}/operating-hours/${hourId}`,payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },

  updateTimezone: async (payload) => {
    try {
      const response = await axios.put(`restaurant-settings`,payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getRestaurentSettings: async (restaurant_id) => {
    try {
        const response = await axios.get(`/restaurant-settings`);
        return response.data.data;
    } catch(e) {
        console.error(e);
    }
},
  upsertOperatingHours: async (restId,payload) => {
    try {
      const response = await axios.patch(`restaurant/${restId}/operating-hours`,payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  upsertHolidays: async (restId,payload) => {
    try {
      const response = await axios.patch(`restaurant/${restId}/holidays`,payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getCateringEvents: async (id) => {
    try {
      const response = await axios.get(`/restaurant_catering_event_types`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  saveCateringEvent: async (data) => {
    try {
        const response = await axios.put(`/restaurant_catering_event_types`, data);
        return response.data.data;
    } catch(e) {
        console.error(e);
    } 
},
deleteCateringEvent: async(id) => {
  try {
      const response = await axios.delete(`/catering-requests/events-types/${id}`);
      return response.data.data;
  } catch(e) {
      console.error(e);
  } 
},
  
};

export default SettingsService;
